"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _palette = _interopRequireDefault(require("../palette"));
var _signetThemeTokens = _interopRequireDefault(require("../signetThemeTokens"));
var _default = {
  contained: {
    padding: '6px 24px'
  },
  root: {},
  containedPrimary: {
    'color': _palette["default"].white,
    'backgroundColor': _signetThemeTokens["default"].primary.main.value,
    '&:hover': {
      backgroundColor: _signetThemeTokens["default"].primary.dark.value
    }
  },
  textPrimary: {
    color: _signetThemeTokens["default"].primary.main.value
  },
  outlinedPrimary: {
    color: _signetThemeTokens["default"].primary.main.value,
    border: "1px solid ".concat(_signetThemeTokens["default"].primary.main.value)
  }
};
exports["default"] = _default;